import { Search } from "@mui/icons-material";

export const InvoicesQueryKeys = {
    Search: "invoices-search",
    FilterValues: "invoices-filter-values",
    Storefronts: "invoices-storefronts",
    StorefrontCurrency: "invoices-storefront-currency"
} as const;